import { twMerge } from 'tailwind-merge';

/**
 * Parse text and highlight/style content with special syntax
 *
 * Supports:
 * - __text__ for turquoise highlighting
 * - **text** for bold text
 * - ~~text~~ for underline text
 *
 * @param text - Text with __content__, **content**, or ~~content~~ to style
 * @returns Array of text and styled spans
 */
export const parseHighlightedText = (text: string, variant: 'singleEvent' | 'referral' = 'singleEvent') => {
  const variantStyles = {
    singleEvent: {
      text: 'tw-text-turquoise',
    },
    referral: {
      text: 'tw-text-[#2D5EFF]',
    },
  };
  // Split by **, __, and ~~ patterns
  const parts = text.split(/(\*\*.*?\*\*|__.*?__|~~.*?~~)/g);

  return parts.map((part, index) => {
    // Handle __text__ for turquoise highlighting
    if (part.startsWith('__') && part.endsWith('__')) {
      const content = part.slice(2, -2);
      return (
        <span key={index} className={twMerge(variantStyles[variant!].text)}>
          {content}
        </span>
      );
    }

    // Handle **text** for bold text
    if (part.startsWith('**') && part.endsWith('**')) {
      const content = part.slice(2, -2);
      return (
        <span key={index} className="tw-font-bold">
          {content}
        </span>
      );
    }

    // Handle ~~text~~ for underline text
    if (part.startsWith('~~') && part.endsWith('~~')) {
      const content = part.slice(2, -2);
      return (
        <span key={index} className="tw-underline">
          {content}
        </span>
      );
    }

    return part;
  });
};
